import { StyleSheet, Platform, Dimensions } from "react-native";

const windowWidth = Dimensions.get("window").width;
const isiPad = Platform.OS === "ios" && windowWidth >= 768;
const isWeb = Platform.OS === "web";

const styles = StyleSheet.create({
  screenRoot: {
    flex: 1,
    backgroundColor: "#eef2f8",
  },
  container: {
    flex: 1,
    paddingHorizontal: 16,
    paddingTop: 8,
  },
  content: {
    flex: 1,
  },
  scrollContent: {
    paddingBottom: 40,
  },
  heroBlock: {
    marginTop: 8,
    marginBottom: 10,
  },
  heroGreeting: {
    fontSize: 28,
    fontWeight: "700",
    color: "#24324a",
    lineHeight: 36,
  },
  heroSubtitle: {
    marginTop: 4,
    fontSize: 14,
    lineHeight: 20,
    color: "#556377",
  },
  kpiRow: {
    marginTop: 14,
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 12,
  },
  kpiCard: {
    minWidth: 150,
    flexGrow: 1,
    paddingVertical: 14,
    paddingHorizontal: 16,
    borderRadius: 10,
    backgroundColor: "#ffffff",
  },
  kpiLabel: {
    fontSize: 11,
    color: "#626d80",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  kpiValue: {
    marginTop: 6,
    fontSize: 28,
    color: "#242d3b",
    fontWeight: "700",
  },
  kpiValueCritical: {
    color: "#c12c01",
  },
  kpiValuePositive: {
    color: "#027c06",
  },
  kpiDelta: {
    marginTop: 4,
    fontSize: 11,
    fontWeight: "700",
  },
  kpiDeltaNeutral: {
    color: "#7a8495",
  },
  kpiDeltaPositive: {
    color: "#0f8b39",
  },
  kpiDeltaWarning: {
    color: "#c75618",
  },
  kpiDeltaCritical: {
    color: "#c12c01",
  },
  sectionLabel: {
    marginTop: 20,
    marginBottom: 10,
    fontSize: 11,
    fontWeight: "700",
    color: "#6f7785",
    letterSpacing: 0.8,
  },
  gridContainer: {
    flexDirection: (isWeb || isiPad) ? "row" : "column",
    flexWrap: (isWeb || isiPad) ? "wrap" : "nowrap",
    gap: 16,
    marginTop: 10,
    marginBottom: 28,
  },
  tileCard: {
    width: isWeb ? "32%" : isiPad ? "48%" : "100%",
    minHeight: 220,
    borderRadius: 12,
    backgroundColor: "#ffffff",
    paddingHorizontal: 24,
    paddingVertical: 24,
    marginBottom: isWeb ? 0 : 12,
    cursor: isWeb ? ("pointer" as any) : undefined,
  },
  tileCardDefault: {
    shadowColor: "rgba(0,94,192,0.08)",
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 1,
    shadowRadius: 24,
    elevation: 2,
    borderWidth: 1,
    borderColor: "transparent",
  },
  tileCardHovered: {
    transform: [{ translateY: -2 }],
    shadowColor: "rgba(0,94,192,0.16)",
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 1,
    shadowRadius: 28,
    elevation: 8,
    borderWidth: 1,
    borderColor: "#e8f0fb",
  },
  tileIconWrap: {
    width: 52,
    height: 52,
    borderRadius: 12,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 14,
  },
  tileTitleRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    marginBottom: 6,
  },
  tileTitle: {
    fontSize: 16,
    color: "#1f2a3b",
    fontWeight: "700",
  },
  tileBadge: {
    fontSize: 11,
    fontWeight: "700",
    color: "#ffffff",
    backgroundColor: "#156fd5",
    borderRadius: 999,
    paddingHorizontal: 10,
    paddingVertical: 2,
    overflow: "hidden",
  },
  tileBadgeAlert: {
    backgroundColor: "#c23603",
  },
  tileDescription: {
    flex: 1,
    fontSize: 13,
    lineHeight: 20,
    color: "#5f697a",
    fontWeight: "500",
  },
  tileFooter: {
    marginTop: 14,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  tileMetric: {
    fontSize: 12,
    color: "#6b7483",
    fontWeight: "600",
  },
  tileMetricAlert: {
    color: "#cd6e12",
  },
  tileArrowCircle: {
    width: 28,
    height: 28,
    borderRadius: 14,
    backgroundColor: "#f2f4f8",
    alignItems: "center",
    justifyContent: "center",
  },
  tileArrowCircleHover: {
    backgroundColor: "#005cbc",
  },
  // legacy — no longer used, kept to avoid import breaks
  tilePressable: {
    flex: 1,
  },
  tilePressableHovered: {
    flex: 1,
  },
  errorText: {
    color: "#d32f2f",
    fontSize: 14,
    padding: 16,
  },
});

export default styles;
